import { render, staticRenderFns } from "./TableSelo.vue?vue&type=template&id=6cad5ded&"
import script from "./TableSelo.vue?vue&type=script&lang=js&"
export * from "./TableSelo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports